import "./Toast.css";

export function Toast({ text, fail }: { text: string; fail?: boolean }) {
  return (
    <div className={`toast-container ${fail ? "failed" : ""}`}>{text}</div>
  );
}
